import { hot } from 'react-hot-loader/root'
import PropTypes from 'prop-types'
import { HashRouter } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { toast, Toaster, ToastBar } from 'react-hot-toast'

import { withFeatureFlags } from '@/providers/featureFlags/FeatureFlagsProvider'
import LoaderProvider from '@/providers/loader/LoaderProvider'
import SessionProvider from '@/providers/session/SessionProvider'
import Router from '@/components/Router'
import Layout from '@/components/Layout/Layout'

import getMessages from '@/translations'
import flattenMessages from '@/utils/flattenMessages'

import '../styles/main.scss'
import '../styles/toaster.scss'

const App = ({ locale = 'en-US' }) => (
  <IntlProvider locale={locale} messages={flattenMessages(getMessages(locale))}>
    <Toaster toastOptions={{ duration: 5000 }}>
      {t => (
        <ToastBar toast={t}>
          {({ message }) => (
            <>
              {message}
              {t.type !== 'loading' && (
                <i onClick={() => toast.dismiss(t.id)} />
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>

    <SessionProvider>
      <LoaderProvider>
        <HashRouter>
          <Layout>
            <Router />
          </Layout>
        </HashRouter>
      </LoaderProvider>
    </SessionProvider>
  </IntlProvider>
)

App.propTypes = {
  locale: PropTypes.string,
}

export default hot(withFeatureFlags(App))
